import { LoggedInUser } from '@ekkogmbh/apisdk';
import { createContextHardened } from 'src/Common/Helper/ContextHelper';

interface SettingsContextValue {
  user?: LoggedInUser;
  isLoading: boolean;
  refetch: () => void;
}

/**
 * Shares the current user (fetched once by SettingsLayout) with the section
 * sub-pages, so Profile/Roles don't each re-request it.
 */
export const [SettingsContext, useSettings] = createContextHardened<SettingsContextValue>('Settings');
